module.exports = __webpack_public_path__ + "img/icon-vote.972df5ec.png";